import { jsxs, jsx } from "react/jsx-runtime";
const NewWorkspaceIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M904.731 157.075C920.757 161.081 932 175.481 932 192V492C932 496.418 928.418 500 924 500H868C863.582 500 860 496.418 860 492V220.108L676 174.108V492C676 496.418 672.418 500 668 500H612C607.582 500 604 496.418 604 492V174.108L420 220.108V837.751L490.422 802.54C495.741 799.88 502 803.748 502 809.695V872.305C502 875.335 500.288 878.105 497.578 879.46L384 936.249L111.9 800.199C99.7041 794.101 92 781.636 92 768V128C92 116.914 97.1074 106.447 105.845 99.6246C114.583 92.8024 125.977 90.3862 136.731 93.0749L384 154.892L640 90.8921L904.731 157.075ZM164 174.108L348 220.108V837.751L164 745.751V174.108Z"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M804 702H970C974.4 702 978 705.6 978 710V766C978 770.4 974.4 774 970 774H804V940C804 944.4 800.4 948 796 948H740C735.6 948 732 944.4 732 940V774H566C561.6 774 558 770.4 558 766V710C558 705.6 561.6 702 566 702H732V536C732 531.6 735.6 528 740 528H796C800.4 528 804 531.6 804 536V702Z" })
] });
export {
  NewWorkspaceIcon
};
